import { styles } from "../../theme/styles";

export const CriticalError = () => {

    return (
        <div style={styles.criticalErrorPage}>
            Error
        </div>
    );
};